import React from 'react';
import { Drawer } from "./Drawer";

export const PrayerDrawer = ({ activeTab, setActiveTab }) => {
    return (
        <Drawer drawerId='prayer' activeTab={activeTab} setActiveTab={setActiveTab}>
            <div className='flex flex-col justify-center items-center pt-10 pb-10'>
                <img
                    className='mb-4'
                    src='/assets/images/jpm-plus-prayer-heart.png'
                    width='53'
                    height='35'
                    alt='Prayer'
                />
                <div className='text-lg font-bold text-center'>A prayer for you</div>
                <p className='text-sm text-center mb-4'>
                    Don’t see what you’re looking for or need further support? Our team is
                    here to pray with you.
                </p>
                <a
                    href='/prayer'
                    as='button'
                    className='btn btn-primary mb-4'
                >
                    Prayer Request
                </a>
            </div>
        </Drawer>
    );
};
